/**
 * URL Decode Command
 * Decode URL-encoded strings
 */
import { Command } from 'commander';
import { UtilsService } from '../../services/utils.service.js';

async function handleUrlDecode(
    input: string,
    options: {
        full: boolean;
    }
): Promise<void> {
    const service = new UtilsService();

    try {
        const decoded = service.urlDecode(input, options.full);

        console.log('🔗 URL Decoded:');
        console.log('────────────────────────────────────────');
        if (options.full) {
            console.log('   Mode: Full URL (decodeURI)');
        } else {
            console.log('   Mode: Component (decodeURIComponent)');
        }
        console.log();
        console.log(`   ${decoded}`);
        console.log();
    } catch (error) {
        console.error('❌ Error:', error instanceof Error ? error.message : String(error));
        process.exit(1);
    }
}

export function createUrlDecodeCommand(): Command {
    const cmd = new Command('url-decode')
        .description('Decode URL-encoded string')
        .argument('<input>', 'Text to decode')
        .option('--full', 'Decode full URL (use decodeURI instead of decodeURIComponent)')
        .addHelpText('after', `
Examples:
  $ jai1 utils url-decode "hello%20world"
  $ jai1 utils url-decode "hello%20world%20%26%20test"
  $ jai1 utils url-decode "name%3DJohn%20Doe%26age%3D30"
  $ jai1 utils url-decode "https://example.com/path%20with%20spaces" --full
`)
        .showHelpAfterError('(add --help for additional examples)')
        .action(async (input, options) => {
            await handleUrlDecode(input, options);
        });

    return cmd;
}
